import { createLucideIcon } from 'lucide-react';
export const WindowCloseSolidIcon = createLucideIcon('window-close-solid-icon', [
  [
    'path',
    {
      d: 'M16 8L8 16',
      key: 'wrjx8b',
    },
  ],
  [
    'path',
    {
      d: 'M20 4H4V20H20V4Z',
      key: '1bnaxz',
    },
  ],
  [
    'path',
    {
      d: 'M8 8L16 16',
      key: 'dou0qj',
    },
  ],
]);
